"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "16",
    height: "10",
    viewBox: "0 0 16 10"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "16",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    width: "16",
    height: "1",
    y: "9"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: ".007 5.014 0 5.021 .707 5.728 .714 5.721 2.121 7.128 2.828 6.421 1.421 5.014 2.828 3.607 2.121 2.9 .714 4.307 .707 4.3 0 5.007 .007 5.014"
  }), ' ', /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "15.922 5.014 15.93 5.022 15.223 5.729 15.215 5.721 13.807 7.129 13.1 6.422 14.508 5.014 13.1 3.607 13.807 2.899 15.215 4.307 15.223 4.299 15.93 5.007 15.922 5.014"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    width: "6",
    height: "2",
    x: "5",
    y: "4",
    rx: "1"
  })));
};

exports["default"] = _default;